import { INSIGHTS_ACTION } from "../actions/insightsActions"
import { Action, InsightsData } from "../types"

export default (state = new InsightsData(), action: Action) => {
  switch (action.type) {
    case INSIGHTS_ACTION.FETCH_TRACK_PLAYLISTS:
      return { ...state, paginatedTrackPlaylists: action.payload }

    default:
      return state
  }
}
